const axios = require('axios');

(() => {
  const selectedCampingRentalCategory = '.camping-rental-category-selection-js';
  const deleteCampingRental = '.delete-selected-each-camping-camping-rental';
  const moveToBarbecueSecondOptionPage = '.move-to-barbecue-second-option-page';
  const moveToCampingSecondOptionPage = '.move-to-camping-guest-page';
  const campingReservationRentalNum = '.camping-reservation-rental-num';
  const campingCampingRentalNum = '.camping-camping-rental-num';
  const campingRentalModalButton = '.camping-rental-modal-button';
  const campingReservationClose = '.camping-reservation-close';
  const campingReservationOpen = '.camping-reservation-open';
  const campingStayInfo = '.camping-stay-info';
  const campingOptionClose = '.camping-option-close';
  const campingOptionOpen = '.camping-option-open';
  const campingOptionInfo = '.camping-option-info';

  const campingSubscriptionClose = '.camping-subscription-close';
  const campingSubscriptionOpen = '.camping-subscription-open';
  const campingSubscriptionInfo = '.camping-subscription-info';

  const campingRentalImage = '.js-camping-rental-img'
  const barbecueCampingRentalNewPath = process.env.JS_BASE_URL + 'customer/barbecue/camping_rental/new';
  var selectedCampingRentalMap = new Map;

  const init = () => {
    if (location.href.indexOf('customer/camping/rental_and_consumable_item') < 1 ) {
      return
    }
    $('body')
      .on('change', selectedCampingRentalCategory, fetchCampingRentals)
      .on('change', campingReservationRentalNum, showSeletedCampingRentals)
      .on('change', campingCampingRentalNum, showSeletedCampingRentals)
      .on('click', deleteCampingRental, deleteSeletedCampingRentals)
      .on('click', campingRentalModalButton, showCampingRentalModalContent)
      .on('click', campingReservationClose, closeStayInfoContent)
      .on('click', campingReservationOpen, showStayInfoContent)
      .on('click', campingOptionClose, closeOptionInfoContent)
      .on('click', campingOptionOpen, showOptionInfoContent)

      .on('click', campingSubscriptionClose, closeSubscriptionInfoContent)
      .on('click', campingSubscriptionOpen, showSubscriptionInfoContent)

      .on('click', campingRentalImage, showSelectedCampingRentalImage);
  }

  const showSelectedCampingRentalImage = e => {
    e.preventDefault();
    const $img = $(e.currentTarget);
    $('.js-slide-target').attr('src', $img.attr('src'));
  }

  const fetchCampingRentals = async e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const categoryId = $element.find('option:selected').val();
    axios.get(process.env.JS_BASE_URL + 'customer/camping/rental_and_consumable_item/camping_rentals', {
      params: { camping_rental_category_id: categoryId },
      xsrfHeaderName: 'X-CSRF-Token',
      withCredentials: true
    })
    .then(response => {
      $('.customer_barbecue_options').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const closeStayInfoContent = e => {
    $(campingReservationClose).fadeOut();
    $(campingStayInfo).fadeOut();
    $(campingReservationOpen).fadeIn();
  }

  const showStayInfoContent = e => {
    $(campingReservationClose).fadeIn();
    $(campingStayInfo).fadeIn();
    $(campingReservationOpen).fadeOut();
  }

  const closeOptionInfoContent = e => {
    $(campingOptionClose).fadeOut();
    $(campingOptionInfo).fadeOut();
    $(campingOptionOpen).fadeIn();
  }

  const showOptionInfoContent = e => {
    $(campingOptionClose).fadeIn();
    $(campingOptionInfo).fadeIn();
    $(campingOptionOpen).fadeOut();
  }

  const closeSubscriptionInfoContent = e => {
    $(campingSubscriptionClose).fadeOut();
    $(campingSubscriptionInfo).fadeOut();
    $(campingSubscriptionOpen).fadeIn();
  }

  const showSubscriptionInfoContent = e => {
    $(campingSubscriptionClose).fadeIn();
    $(campingSubscriptionInfo).fadeIn();
    $(campingSubscriptionOpen).fadeOut();
  }

  const showCampingRentalModalContent = e => {
    const $element = $(e.currentTarget);
    const selectedCampingRentalId = $element[0].dataset.campingRentalId;
    const campingRentals = $('#data-camping-rental').data('camping-rentals');
    const campingRentalImages = $('#data-camping-rental-image').data('camping-rental-images');
    campingRentals.forEach(rental => {
      if (rental.id == selectedCampingRentalId) {
        var targetCampingRentalImages = campingRentalImages.filter(image => image.camping_rental_id == rental.id)
        $('.camping-rental-detail-modal').empty();
        $('.camping-rental-detail-modal').append(buildCampingRentalModal(rental, targetCampingRentalImages));
      }
    })
  }

  const showImage = (images, key) => {
    if (images[key] != null) {
      return `<img class="camping-rental-float-image js-camping-rental-img" src="${images[key].image.admin_show_thumb.url}">`;
    }
    return '';
  }

  const buildCampingRentalModal = (rental, images) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const charge = rental.charge * (1 + taxRate);
    var campingRental =
    `
      <div class="modal-body">
        <div class="price-block">
          <div class="block-left js-slide">
            <img src=${images[0].image.admin_show_thumb.url} class="js-slide-target">
            <div class="camping-rental-float-images">
              ${showImage(images, 0)}
              ${showImage(images, 1)}
              ${showImage(images, 2)}
              ${showImage(images, 3)}
            </div>
          </div>
          <div class="block-right">
            <div class="brand">${rental.brand_name}</div>
            <div class="title">${rental.rental_name}</div>
            <div class="modal_product_number mb-3">${rental.product_number}</div>
            <div class="price-block">
              <span class="tax">（税込）</span>
              <span class="price">${charge.toLocaleString()}</span>
              <span class="unit">円</span>
            </div>
          </div>
        </div>
        <div class="description modal-description">${rental.description}</div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return campingRental;
  }

  const showSeletedCampingRentals = async e => {
    const $element = $(e.currentTarget);
    const seletedCampingRentalNum = $element.find('option:selected').val();
    const rest = $element.data('rest')
    const errorElement = $element.data('error')
    let prms = {}
    if ($element.data('rental-id')) {
      prms['camping_rental_id'] = $element.data('rental-id')
    }
    if ($element.data('cookware-rental-id')) {
      prms['cookware_rental_id'] = $element.data('cookware-rental-id')
    }
    if ($element.data('consumable-item-id')) {
      prms['consumable_item_id'] = $element.data('consumable-item-id')
    }

    prms['num'] = seletedCampingRentalNum;

    if (rest && seletedCampingRentalNum > rest) {
      $(errorElement).empty();
      $(errorElement).append(`<p class='barbecue-camping-rental-error-message'>上限を超えています</p>`);
      return;
    }
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/camping/rental_and_consumable_item',
      method: 'POST',
      data: prms,
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      $element.val(seletedCampingRentalNum)
      if ($element.data('rental-id')) {
        let rental_id = $element.data('rental-id')
        $(`.camping_reservation_rental_num-${rental_id}`).val(seletedCampingRentalNum)
      }
      if ($element.data('cookware-rental-id')) {
        let rental_id = $element.data('cookware-rental-id')
        $(`.camping-reservation-cookware-rental-num-${rental_id}`).val(seletedCampingRentalNum)
      }
      if ($element.data('consumable-item-id')) {
        let item_id = $element.data('consumable-item-id')
        $(`.camping-reservation-consumable-item-num-${item_id}`).val(seletedCampingRentalNum)
      }

      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const deleteSeletedCampingRentals = (e) => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    let prms = {}
    if ($element.data('rental-id')) {
      prms['camping_rental_id'] = $element.data('rental-id')
    }
    if ($element.data('cookware-rental-id')) {
      prms['cookware_rental_id'] = $element.data('cookware-rental-id')
    }
    if ($element.data('consumable-item-id')) {
      prms['consumable_item_id'] = $element.data('consumable-item-id')
    }


    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/camping/rental_and_consumable_item',
      method: 'DELETE',
      data: prms,
      withCredentials: true,
      headers: {'X-CSRF-Token': token}
    })
    .then(response => {
      if ($element.data('rental-id')) {
        let rental_id = $element.data('rental-id')
        $(`.camping_reservation_rental_num-${rental_id}`).val(0)
      }
      if ($element.data('cookware-rental-id')) {
        let rental_id = $element.data('cookware-rental-id')
        $(`.camping-reservation-cookware-rental-num-${rental_id}`).val(0)
      }
      if ($element.data('consumable-item-id')) {
        let item_id = $element.data('consumable-item-id')
        $(`.camping-reservation-consumable-item-num-${item_id}`).val(0)
      }

      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
    return false
  };

  $(init);
})();

